import { render, staticRenderFns } from "./TeacherLogin.vue?vue&type=template&id=7c1daf64&scoped=true&lang=pug&"
import script from "./TeacherLogin.vue?vue&type=script&lang=ts&"
export * from "./TeacherLogin.vue?vue&type=script&lang=ts&"
import style0 from "./TeacherLogin.vue?vue&type=style&index=0&id=7c1daf64&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1daf64",
  null
  
)

export default component.exports